import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {RightColumn} from "../../Common/pages/RightColumn";
import {StandardPage} from "../../Common/pages/StandardPage";

export default class FootballFixturesLayout extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
    FootballFixturesResults: PropTypes.element,
    FootballCompetitionFixturesResults: PropTypes.element,
    FootballTeamFixturesResults: PropTypes.element
  };

  render() {
    const {
      location,
      FootballFixturesResults,
      FootballCompetitionFixturesResults,
      FootballTeamFixturesResults,
      route
    } = this.props;

    return (
      <StandardPage sport="racing" title="Fixtures" >
        <div className="main-layout-left-column">
          {FootballFixturesResults &&
            React.cloneElement(FootballFixturesResults, { fixturesResults: route.fixturesResults })
          }
          {FootballCompetitionFixturesResults &&
            React.cloneElement(FootballCompetitionFixturesResults, { fixturesResults: route.fixturesResults })
          }
          {FootballTeamFixturesResults &&
            React.cloneElement(FootballTeamFixturesResults, { fixturesResults: route.fixturesResults })
          }
        </div>

        <RightColumn location={location}
                     sport="football"
                     content={["topMpu", "ocWidget"]} />
      </StandardPage>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballFixturesLayout.js